
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    props: [{
        type_logo: {
            type: String,
            default: 'white'
        }
    }],
    components: {
        vcDynamicLink	: () => import('../../components/pages/dynamic-link.vue')
    },
    data() {
        return {
            testimonial_slideshow: []
        }
    },
    mounted(){
        this.testimonial_slideshow = this.getterReviews ? this.getRandomItems(this.getterReviews, 20) : [];

        setTimeout(() => {

            this.testimonial_slideshow = this.getterReviews ? this.getRandomItems(this.getterReviews, 20) : [];
        }, 60000);
    },
    computed:{
        ...mapGetters({
            getterReviews: 'getterReviews',
        }),
        getSlideshow(){
            
            return this.testimonial_slideshow;
        }
    },
    methods: {
        hideAvatarImage(index){
            
            this.testimonial_slideshow[index].author.avatar.show = true;
        },
        testimonialDate(date){
            
            return moment(date).fromNow();
        },
        getRandomItems(array, numItems) {
            return array.sort(() => 0.5 - Math.random()).slice(0, numItems);
        }
    }
}
